import React from 'react';
import PropTypes from 'prop-types';
import {SLICE_PROP_TYPES} from '../cms-prop-types';
import {RichText} from 'prismic-reactjs';
// Creating in advance of using CSS modudles with dex
// import css from './RichTextWithTitle.module.scss';

const RichTextWithTitle = ({slice}) => (
    <div className="RichTextWithTitle">
        {RichText.render(slice.primary.title)}
        {RichText.render(slice.primary.rich_text_section)}
    </div>
);

/* eslint-disable camelcase */
RichTextWithTitle.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            title: PropTypes.array.isRequired,
            rich_text_section: PropTypes.array.isRequired,
        }).isRequired,
    }).isRequired,
};

export default RichTextWithTitle;
